import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";

export default class RemoveOrganisationIndexInteractor {
  private resource: DeleteResourceInteractor;

  constructor({ deleteResource }) {
    this.resource = deleteResource;
  }

  execute(organisationId: number, indexId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.indexes}`,
      indexId
    );
  }
}
